import { Stack, Typography, Box, CircularProgress, Alert, Button, Grid } from '@mui/material'
import { Add as AddIcon } from '@mui/icons-material'

import AddCreditCardModal from '../AddCreditCardModal/AddCreditCardModal'

import { PaymentMethodCard } from './PaymentMethodCard'

export function PaymentMethodsSection({
  paymentMethods,
  selectedPaymentMethod,
  onPaymentMethodSelect,
  onAddPaymentMethod,
  isLoading,
  showAddCard,
  onSetupSuccess,
  onSetupError,
  onCancelAddCard,
  title = 'Payment Method',
  // Optional props for billing mode (SetupIntent)
  clientSecret,
  creatingSetupIntent,
  onDeletePaymentMethod,
  isBillingMode = false, // Explicitly control billing mode
  deletingPaymentMethodId, // ID of payment method currently being deleted
}) {
  return (
    <Stack direction="column" gap="16px" justifyContent="center" width="100%">
      <Stack alignItems="center" direction="row" gap="16px" justifyContent="space-between" width="100%">
        <Typography color="#101828" fontSize={14} fontWeight={600} lineHeight="24px">
          {title}
        </Typography>
        <Button
          disabled={creatingSetupIntent}
          size="small"
          startIcon={<AddIcon />}
          sx={{ color: '#A12F7E' }}
          onClick={onAddPaymentMethod}
        >
          {creatingSetupIntent ? 'Adding...' : 'Add New Card'}
        </Button>
      </Stack>

      {isLoading ? (
        <Box display="flex" justifyContent="center" p={2}>
          <CircularProgress />
        </Box>
      ) : paymentMethods.length === 0 ? (
        <Alert severity="info">No payment methods found. Please add a card to continue.</Alert>
      ) : (
        <Grid container spacing={2}>
          {paymentMethods.map(pm => (
            <Grid key={pm.id} item sm={6} xs={12}>
              <PaymentMethodCard
                deletingPaymentMethodId={deletingPaymentMethodId}
                isSelected={selectedPaymentMethod?.id === pm.id}
                paymentMethod={pm}
                showDelete={isBillingMode}
                onClick={() => onPaymentMethodSelect(pm)}
                onDelete={onDeletePaymentMethod}
              />
            </Grid>
          ))}
        </Grid>
      )}
      <AddCreditCardModal
        clientSecret={clientSecret}
        isBillingMode={isBillingMode}
        open={showAddCard}
        onClose={onCancelAddCard}
        onSetupError={onSetupError}
        onSetupSuccess={onSetupSuccess}
      />
    </Stack>
  )
}
